import { combine, createEvent, createStore, sample } from 'effector'
import { persist } from 'effector-storage/local'
import { profilesModel } from '~/entities/profiles'
import { noop } from '~/shared/effector'

export const updateLastWatchedContent = createEvent<string>()

/**
 * Internal store: profileId -> last watched content title.
 */
const updateLastWatchedContentWithProfile = createEvent<{
  profileId: string
  title: string
}>()

const $lastWatchedContentInternal = createStore<Record<string, string>>({}).on(
  updateLastWatchedContentWithProfile,
  (state, { profileId, title }) => ({
    ...state,
    [profileId]: title,
  })
)

sample({
  clock: updateLastWatchedContent,
  source: profilesModel.$activeProfileId,
  filter: (profileId): profileId is number =>
    profileId != null && profileId !== 0,
  fn: (profileId, title) => ({
    profileId: String(profileId),
    title,
  }),
  target: updateLastWatchedContentWithProfile,
})

// we do not use scopes for now, so, ignore this rule
// eslint-disable-next-line effector/require-pickup-in-persist
persist({
  store: $lastWatchedContentInternal,
  key: 'tria__last-watched-content',
  fail: noop,
})

/**
 * Last watched content for the currently active profile.
 */
export const $lastWatchedContent = combine(
  $lastWatchedContentInternal,
  profilesModel.$activeProfileId,
  (internal, profileId) =>
    profileId != null ? (internal[String(profileId)] ?? null) : null
)
